/**
 * Helper de rendu des styles d'image config par l'admin (champ config.image_style).
 * Doit rester strictement aligne avec frontend/src/pages/super-admin/vitrine/blocks/ImageStyleControls.jsx :
 * memes enums, memes defauts, memes mappings.
 *
 * Usage cote rendu :
 *   const { wrapperStyle, imgStyle } = computeImageStyle(config.image_style)
 *   return <div style={wrapperStyle}><img style={imgStyle} src={...} /></div>
 *
 * - wrapperStyle : applique a un container (controle la TAILLE / position)
 * - imgStyle     : applique au <img> (controle bord/ombre/radius)
 */

const SIZE_MAX_WIDTH = {
  small:     '420px',
  medium:    '560px',
  large:     '720px',     // ≈ comportement actuel (avant config)
  fullwidth: '100%',
};

const RADIUS_PX = {
  none:   '0',
  small:  '4px',
  medium: '16px',          // ≈ comportement actuel
  large:  '32px',
  circle: '50%',
};

const SHADOW = {
  none:   'none',
  soft:   '0 4px 16px rgba(0,0,0,0.06)',
  medium: '0 20px 60px rgba(0,0,0,0.10)', // ≈ comportement actuel
  strong: '0 30px 80px rgba(0,0,0,0.18)',
};

const BORDER = {
  none:   'none',
  light:  '1px solid #e5e7eb',
  medium: '2px solid #cbd5e1',
  accent: '2px solid var(--color-primary, #e27228)',
};

const DEFAULTS = {
  size:   'large',
  radius: 'medium',
  shadow: 'medium',
  border: 'none',
};

export function computeImageStyle(imageStyle = {}) {
  const v = { ...DEFAULTS, ...(imageStyle || {}) };
  const radiusVal = RADIUS_PX[v.radius] ?? RADIUS_PX.medium;
  const aspect = v.radius === 'circle' ? '1 / 1' : undefined;
  return {
    wrapperStyle: {
      maxWidth: SIZE_MAX_WIDTH[v.size] ?? SIZE_MAX_WIDTH.large,
      width: '100%',
      // Si fullwidth, on collse a gauche (le grid prend deja en charge la column)
      // Sinon on centre dans sa col.
      marginLeft: v.size === 'fullwidth' ? 0 : 'auto',
      marginRight: v.size === 'fullwidth' ? 0 : 'auto',
    },
    imgStyle: {
      width: '100%',
      display: 'block',
      borderRadius: radiusVal,
      boxShadow: SHADOW[v.shadow] ?? SHADOW.medium,
      border: BORDER[v.border] ?? BORDER.none,
      ...(aspect ? { aspectRatio: aspect, objectFit: 'cover' } : {}),
    },
  };
}
